var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_6443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.19136V4.19136C8.50062 3.57139 8.27086 2.97329 7.85531 2.51319C7.43977 2.05309 6.86809 1.76381 6.25125 1.70151C5.63441 1.6392 5.01643 1.80831 4.51726 2.17602C4.0181 2.54372 3.67337 3.08378 3.55 3.69136M9.5 6.19136H2.5C1.94771 6.19136 1.5 6.63908 1.5 7.19136V10.6914C1.5 11.2436 1.94771 11.6914 2.5 11.6914H9.5C10.0523 11.6914 10.5 11.2436 10.5 10.6914V7.19136C10.5 6.63908 10.0523 6.19136 9.5 6.19136Z",
    stroke: "#726C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_6443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0.691406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.0768005a5ef3aac677556ebe8f01078f.svg";
export { ForwardRef as ReactComponent };